export default "__VITE_ASSET__yS1$JRz0__"